/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.0
 */
import ICommonTranslationRange from '../../types/common/range';

const initTranslationRange: ICommonTranslationRange = {
    ok: '',
    placeholder: '',
};

export default initTranslationRange;
